import axios from "axios";
import { IsAuthorized } from "src/authentication/IsAuthorized";
import { getJWT } from "src/helper/localStore/getJWT";

class ItemSupplierService {
    async getItemsSupplier(params:any): Promise<any>{
        try {
            const res = await axios.get(
            `${process.env.REACT_APP_URL_RESERVATION}/item-supplier/`,
                {
                    headers: { 'authentication-token': getJWT()! },
                    params
                }
            );
            return {data:res.data, total:res['headers']['row-counter']}
        } catch (error) {
            IsAuthorized(error);
            throw error;
        }
    }

  async updateItemSupplier(id: number, body: object): Promise<any> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/item-supplier/${id}`,
        body,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createItemSupplier(body: object): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item-supplier/`,
        body,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createItemSecondarySupplier(body: object): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item-supplier/secondary`,
        body,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
  
}

export const itemSupplierService = new ItemSupplierService();